// 3rd party imports
import * as React from 'react';

// mobx
import { Program } from 'models';

// ui
import { UitkFigure, UitkImage, UitkFigureAspectRatioType } from 'uitk-react-images';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

export interface ProgramCardLogoProps {
  program: Program;
}

export const ProgramCardLogo: React.FunctionComponent<ProgramCardLogoProps> = ({ program }) => {
  return <img className="ProgramCard__logo" src={program.img} alt={program.name} />;
};
